// eslint-disable-next-line import/extensions
import type { ITGMetadata } from "@ceeferenderer/fe-renderer-sdk/model/itgMetadata.model";
import type { ResponseConsumer } from "@ceeferenderer/fe-renderer-sdk";
import { handleError } from "./handleError";
import { handleExit } from "./handleExit";
import { handleRender } from "./handleRender";
import { postLoggerEventDetails } from "../../utils/nifiLogger";

type CustomAttribute = {
  key: string;
  value: string;
};
type WorkLog = {
  customAttributes?: CustomAttribute[];
};

export type Response = ResponseConsumer & {
  metaData: ITGMetadata;
  workLog: WorkLog;
};

export const handleResponse = ({ html, metaData, errors, isExit, workLog }: Response): void => {
  sessionStorage.setItem("ev_sessionId", metaData?.sessionId ? metaData?.sessionId : "");
  sessionStorage.setItem("ev_stepId", metaData?.stepId ? metaData?.stepId : "");
  sessionStorage.setItem("ev_pageName", metaData?.pageName ? metaData?.pageName : "");
  sessionStorage.setItem("ev_itgName", metaData?.itgName ? metaData?.itgName : "");
  const locationId = new URLSearchParams(window.location.search).get("locationId");
  if (errors || !locationId) {
    if (!locationId) {
      handleRender(html, metaData);
    }
    sessionStorage.setItem("ev_status", "failure");
    if (Array.isArray(errors) && errors.length) {
      sessionStorage.setItem("ev_statusCode", errors[0].statusCode ? errors[0].statusCode : "");
    } else {
      sessionStorage.setItem("ev_statusCode", "");
    }
    handleError(errors, metaData);
  } else if (isExit) {
    sessionStorage.setItem("ev_exit", "true");
    sessionStorage.setItem("ev_status", "success");
    sessionStorage.setItem("ev_statusCode", "");
    handleExit(workLog?.customAttributes?.find(({ key }) => key === "exitOption")?.value);
  } else {
    sessionStorage.setItem("ev_exit", "false");
    sessionStorage.setItem("ev_status", "success");
    sessionStorage.setItem("ev_statusCode", "");
    handleRender(html, metaData);
    const locRespAddress1 = document.querySelector("[rsmonitor='location_response_addr1']");
    const locRespAddress1Value = locRespAddress1?.getAttribute("value");
    const itemStr = localStorage.getItem("cimaSuccessful");
    const item = itemStr ? JSON.parse(itemStr) : null;
    if (
      (!item && locRespAddress1Value === "") ||
      (item && item.value && item.value === "true" && localStorage.getItem("locRespAddress1") === "")
    ) {
      handleError(errors, metaData);
    }
  }
  if (sessionStorage.getItem("ev_isExistingUserClick") === "true") {
    postLoggerEventDetails("R360_Anticipated_Visits_UI_CIMA_Redirect", "Retail_BusinessTransaction");
    sessionStorage.removeItem("ev_isExistingUserClick");
  }
  postLoggerEventDetails("R360_Anticipated_Visits_UI_Page_Launch", "Retail_BusinessTransaction");
};
